import axios from 'axios';
import { apiTransitionPayloadCollection, submitPayloadDataFailure } from '../../../actions/travelUg/payloadCollection';
import {
    getAccessToken,
    getIsApiPending,
    getNetworkProvider,
    getPaymentMode,
    getPhoneNumber,
} from '../../../selectors/travelUg/payments';
import {
    getAlternateUgxPremium,
    getCustomerIdValue,
    getQuoteForm,
    getUgxPremium,
} from '../../../selectors/travelUg/quote';
import { setBankDetailsSuccess, setStkRequestId } from '../../../actions/travelUg/payments';

export const submitPaymentDataService = async (store, next, action) => {
    if (getIsApiPending(store.getState())) {
        return next(action);
    }

    store.dispatch(apiTransitionPayloadCollection.pending());

    try {
        const state = store.getState();
        const modeOfPayment = getPaymentMode(state);

        if (modeOfPayment === 'Flexipay') {
            await handleFlexipayPayment(store, state, modeOfPayment);
        } else if (modeOfPayment === 'Bank') {
            await handleBankPayment(store, state, modeOfPayment);
        }

        store.dispatch(apiTransitionPayloadCollection.success());
    } catch (error) {
        console.error(error);
        store.dispatch(submitPayloadDataFailure(error));
        store.dispatch(apiTransitionPayloadCollection.failure());
    }

    return next(action);
};

const handleFlexipayPayment = async (store, state, modeOfPayment) => {
    store.dispatch(setBankDetailsSuccess(false));
    await makePaymentSubmission(state, store, modeOfPayment);
};

const handleBankPayment = async (store, state, modeOfPayment) => {
    await makePaymentSubmission(state, store, modeOfPayment);
    store.dispatch(setBankDetailsSuccess(true));
};

function getCurrentTimestamp() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
    return timestamp;
}

function formatPhoneNumber(phoneNumber, countryCode) {
    const cleanedNumber = phoneNumber.substring(1);
    const formattedNumber = `${countryCode}${cleanedNumber}`;

    return formattedNumber;
}

const determineUserTotalPremium = (ugxPremium, alternateUgxPremium, selectedCover) => {
    if (typeof selectedCover.value !== 'string') return 0;
    return selectedCover.value.includes('Elite') ? alternateUgxPremium || 0 : ugxPremium || 0;
};

const payloadCollection = (state, store, modeOfPayment) => {
    const customerId = getCustomerIdValue(state);
    const ugxPremium = getUgxPremium(state);
    const quotation = getQuoteForm(state);
    const alternateUgxPremium = getAlternateUgxPremium(state);

    if (modeOfPayment === 'Flexipay') {
        const requestId = getCurrentTimestamp();
        store.dispatch(setStkRequestId(requestId));

        const phoneNumber = getPhoneNumber(state);
        const msisdn = formatPhoneNumber(phoneNumber.value, '256');
        const networkProvider = getNetworkProvider(state);

        //TODO: remove 500 in prod
        const payload = {
            id: customerId?.value,
            transactionRef: requestId,
            modeOfPayment: modeOfPayment.toUpperCase().trim(),
            msisdn,
            amount: determineUserTotalPremium(ugxPremium, alternateUgxPremium, quotation.selectedCover),
            sourceSystem: networkProvider.value || '',
            narrative: 'UG Travel Insurance',
            requestId,
            referenceNumber: requestId,
        };

        return payload;
    }

    if (modeOfPayment === 'Bank') {
        const bankPayload = {
            id: customerId?.value,
            modeOfPayment: modeOfPayment.toUpperCase().trim(),
            amount: determineUserTotalPremium(ugxPremium, alternateUgxPremium, quotation.selectedCover),
        };

        return bankPayload;
    }
};

export const makePaymentSubmission = async (state, store, modeOfPayment) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/travel-ug/submit/payment-data';
        return await axios.post(url, payloadCollection(state, store, modeOfPayment), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
